import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useProfileSpecialistCreateStyles = makeStyles((theme) =>
  createStyles({
    root: {
      margin: '0 -16px',

      [theme.breakpoints.up('sm')]: {
        margin: 'auto',
        width: 550
      }
    },

    buttonUpload: {
      display: 'block',
      textAlign: 'center'
    },

    wrapper: {
      boxShadow: '0 0 25px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff',
      margin: '24px 0 32px 0',
      padding: 22,

      [theme.breakpoints.up('sm')]: {
        padding: 20
      },

      [theme.breakpoints.up('md')]: {
        padding: 30
      },

      [theme.breakpoints.up('lg')]: {
        padding: 30
      }
    },

    button: {
      marginLeft: 'auto',
      marginTop: 14,
      padding: '5px 10px'
    },

    action: {
      display: 'flex'
    },

    name: {
      marginBottom: 16
    },

    row: {
      marginBottom: 16
    }
  })
)
